export default class BusinessUnit {
  id: string;

  name: string;

  code: number;

  active: boolean;

  company: number;

  externalId: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.code = obj.email || '';
    this.active = obj.active || '';
    this.company = obj.company || '';
    this.externalId = obj.externalId || '';
  }

  public static of(obj: any): BusinessUnit {
    return new BusinessUnit(obj);
  }

  public static ofEmpty(): BusinessUnit {
    return new BusinessUnit({});
  }

  public static ofList(members: any): BusinessUnit[] {
    return members.map((businessUnit: any) => new BusinessUnit(businessUnit));
  }
}
